import React from "react";
import { Button } from "reactstrap";

function renderButton({ text, loading, ...rest }, color, icon, defaultText) {
  return loading ? (
    <Button color={color} {...rest}>
      <i className="fa fa-spinner fa-spin" /> Carregando
    </Button>
  ) : (
    <Button color={color} {...rest}>
      <i className={icon} /> {text ? text : defaultText}
    </Button>
  );
}

function print() {
  window.print();
}

const LogoutButton = (props) => {
  return renderButton(props, "light", "fa fa-sign-out", "");
};

const EditButton = (props) => {
  return renderButton(props, "info", "fa fa-edit", "Editar");
};

const DetailsButton = (props) => {
  return renderButton(props, "info", "fa fa-list", "Detalhes");
};

const RemoveButton = (props) => {
  return renderButton(props, "danger", "fa fa-trash", "Remover");
};

const NewButton = (props) => {
  return renderButton(props, "primary", "fa fa-plus", "Novo");
};

const UpdateButton = (props) => {
  return renderButton(props, "primary", "fa fa-edit", "Atualizar");
};

const ExcelButton = (props) => {
  return renderButton(props, "success", "fa fa-file-excel-o", "Excel");
};

const TermoButton = (props) => {
  return renderButton(props, "success", "fa fa-file-word-o", "Gerar Termo");
};

const PdfButton = (props) => {
  return renderButton(props, "success", "fa fa-file-pdf-o", "Baixar PDF");
};

const GoBackButton = (props) => {
  return renderButton(props, "secondary", "", "Voltar");
};

const PrintButton = (props) => {
  return renderButton(
    { onClick: print, ...props },
    "primary",
    "fa fa-print",
    "Imprimir"
  );
};

export {
  EditButton,
  RemoveButton,
  NewButton,
  UpdateButton,
  PrintButton,
  DetailsButton,
  ExcelButton,
  TermoButton,
  PdfButton,
  LogoutButton,
  GoBackButton,
};
